import * as Sentry from '@sentry/react';
import { RefreshCw } from 'lucide-react';
import { useEffect, useState } from 'react';
import errorIllustration from '../../assets/images/exclamation-mark.png';
import { Button } from '../button/button';
import { Stack } from '../stack/stack';

type ErrorSectionProps = {
  error?: Error;
};

export const ErrorSection = ({ error }: ErrorSectionProps) => {
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (error) {
      Sentry.captureException(error);
    }
  }, [error]);

  return (
    <Stack space={4} align="center" className="mt-48">
      <Stack space={2} align="center">
        <div className="h-40 w-40">
          <img
            src={errorIllustration}
            alt=""
            loading="eager"
            fetchpriority="high"
            className="h-full w-full object-cover"
          />
        </div>

        <h2 className="text-center text-2xl font-medium">Something went wrong</h2>

        <p className="text-center text-base font-medium text-muted-foreground">
          We've been notified of the issue. Please try refreshing the page.
        </p>
      </Stack>

      <Button
        iconLeft={<RefreshCw size={16} />}
        isLoading={isLoading}
        onClick={() => {
          setIsLoading(true);

          window.location.reload();
        }}
      >
        Refresh Page
      </Button>
    </Stack>
  );
};
